module.exports = __webpack_public_path__ + "static/media/doted_questionmark.8b2100c9.png";